import React, { useEffect, useState } from 'react';
import { Container, Card, Spinner, Alert } from 'react-bootstrap';
import api from '../../api/apiClient';
import LandingNavbar from './Navbar';

const TermsOfUsePage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await api.terms.getCurrent();
        if (response.data?.success) {
          setTerms(response.data.data || null);
        } else {
          setError(response.data?.message || 'Failed to load Terms of Use');
        }
      } catch (err) {
        const message = err.response?.data?.message || err.message;
        setError(message || 'Failed to load Terms of Use');
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  return (
    <div className="min-vh-100 d-flex flex-column bg-light">
      <LandingNavbar />
      
      <div className="flex-grow-1 pt-5 mt-5">
        <Container className="py-4">
          <Card className="shadow-sm">
            <Card.Body className="p-4 p-md-5">
              <h1 className="mb-4">Terms of Use</h1>

              {loading && (
                <div className="text-center py-4">
                  <Spinner animation="border" />
                </div>
              )}

              {error && !loading && (
                <Alert variant="danger">
                  {error}
                </Alert>
              )}

              {!loading && !error && !terms && (
                <div className="text-muted">
                  No Terms of Use have been published yet.
                </div>
              )}

              {!loading && !error && terms && (
                <>
                  <div className="text-muted mb-3">
                    Version {terms.version}{' '}
                    {terms.published_at && (
                      <>
                        (published on {new Date(terms.published_at).toLocaleDateString()})
                      </>
                    )}
                  </div>
                  <div 
                    className="terms-content"
                    dangerouslySetInnerHTML={{ __html: terms.content || '' }} 
                  />
                </>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>

      <footer className="bg-dark text-white py-4 mt-auto">
        <Container>
          <div className="text-center">
            <p className="mb-0">© {new Date().getFullYear()} Enable LXP. All rights reserved.</p>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default TermsOfUsePage;
